import { WhiteBox } from '@/components/Layout'
import React, { useCallback, useMemo, useState } from 'react'
import { actionButtonsColumnProps, BsrsGrid, DateCell, DateFilterCell, LookupCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid/dist/npm/GridColumn'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import moment from 'moment'
import { Button } from '@/components/button'
import { useDispatch } from '@/hooks/dispatch'
import { actionCreators as identityActions } from '@/store/Identity'
import debug from 'debug'

const log = debug('app:impersonation')

const Impersonation = React.memo(function Impersonation (props) {
  const { localize } = useLocalization()
  const dispatch = useDispatch()
  const minute = moment().format('yyyy-MM-dd hh:mm')
  const [ts, setTs] = useState(minute)
  const refresh = useCallback(() => {
    setTs(moment().format('yyyy-MM-dd hh:mm:ss'))
  }, [])

  const impersonate = useCallback((item) => {
    const userId = item.impersonatedUser.id
    context.api.loginService.impersonate(userId)
      .then(() => {
        dispatch(identityActions.userExpired())
        dispatch(identityActions.loadUser())
      }).catch((err) => {
        log(err)
      })
  }, [dispatch])

  const rowButtons = useMemo(() => [
    {
      icon: 'group',
      onClick: impersonate,
      title: localize('UserProfile.Impersonate')
    }
  ], [impersonate, localize])

  const impersonationDataSource = useCallback((request, options) => {
    request && request.sort && request.sort.forEach(x => {
      if (x.field.startsWith('impersonatedUser')) {
        x.field = 'impersonatedUserName'
      }
    })
    return context.api.impersonationService.getAvailableImpersonations(request, options)
  }, [])

  const impersonatorsDataSource = useCallback((request, options) => {
    request && request.sort && request.sort.forEach(x => {
      if (x.field.startsWith('impersonatorUser')) {
        x.field = 'impersonatorUserName'
      }
    })
    return context.api.impersonationService.getActiveImpersonators(request, options)
  }, [])

  return (
    <React.Fragment>
      <WhiteBox
        header='UserProfile.AvailableImpersonations' buttons={<Button onClick={refresh}>{localize('Common:Refresh')}</Button>}>
        <BsrsGrid simpleView dataSource={impersonationDataSource} key={`grid_${ts}`}>
          <Column field='impersonatedUser' title={localize('UserProfile.ImpersonatedUser')} cell={LookupCell} width='450px' />
          <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
          <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
          <Column {...actionButtonsColumnProps(rowButtons)} />
        </BsrsGrid>
      </WhiteBox>

      <WhiteBox
        header='UserProfile.Impersonators' buttons={<Button onClick={refresh}>{localize('Common:Refresh')}</Button>}>
        <BsrsGrid simpleView dataSource={impersonatorsDataSource} key={`grid_${ts}`}>
          <Column field='impersonatorUser' title={localize('UserProfile.ImpersonatedUser')} cell={LookupCell} width='450px' />
          <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
          <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
        </BsrsGrid>
      </WhiteBox>
    </React.Fragment>
  )
})

export {
  Impersonation
}



// WEBPACK FOOTER //
// ./src/components/userProfile/impersonation.js